import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'phone' })
export class PhoneFormatPipe implements PipeTransform {
  transform(value: string) {
    if (value)
      return '+' + value.substr(0, 1) + ' (' + value.substr(1, 3) + ') ' + value.substr(4, 3) + '-' + value.substr(7, 4);
  }
}